export default __webpack_public_path__ + "static/media/windows-logo.9cbe39cc.svg";